import React, { useCallback } from 'react';
import _ from 'lodash';
import { Row, Col } from 'reactstrap';

import { Select } from 'components';
import moment from 'moment';

export default ( {
  options, form, values, onComplete, setBlockNavigationAlert,
} ) => {
  const country = _.find( options.tariffs, { country: form.getState().values.country } );

  const completeSteps = useCallback( ( completed ) => {
    if ( completed ) {
      onComplete( [
        { step: 0, completed: true },
        { step: 1, completed: false },
        { step: 2, completed: false },
        { step: 3, completed: false },
      ] );
    } else {
      onComplete( [
        { step: 0, completed: false },
        { step: 1, completed: false },
        { step: 2, completed: false },
        { step: 3, completed: false },
      ] );
    }
  }, [onComplete] );

  return (
    <Row>
      <Col md={6} className="m-auto">
        <Select
          field="country"
          placeholder="campaignWizardCountry"
          options={options.tariffs}
          labelKey="countryName"
          idKey="country"
          onChange={( value, previousValue, valueItem ) => {
            setBlockNavigationAlert( true );
            const newValues = { ...values, country: value };
            if ( value && valueItem ) {
              newValues.phoneNumberCountryCode = valueItem.original.codePhone;
              newValues.rate = valueItem.original.id;
              newValues.ratePriceMinute = valueItem.original.priceMinute;
            }
            if ( values.timeZone ) {
              const newCountry = _.find( options.tariffs, { country: value } );
              if ( newCountry && newCountry.timeZones && newCountry.timeZones[0] ) {
                // eslint-disable-next-line prefer-destructuring
                newValues.timeZone = newCountry.timeZones[0];
                if ( values.startDate ) newValues.startDate = moment.tz( newCountry.timeZones[0] );
                if ( values.startTime ) newValues.startTime = moment.tz( newCountry.timeZones[0] );
                completeSteps( true );
              } else {
                completeSteps( false );
              }
            }
            form.initialize( newValues );
          }}
        />
        <Select
          field="timeZone"
          placeholder="campaignWizardTimezone"
          options={country
            ? _.map( country.timeZones, ( item ) => ( { id: item, name: item } ) ) : []}
          formGroupClass="m-0"
          isDisabled={!country}
          onChange={( value ) => {
            const newValues = {
              ...values,
              country: values.country,
              timeZone: value,
              phoneNumberCountryCode: values.phoneNumberCountryCode,
              rate: values.rate,
              ratePriceMinute: values.ratePriceMinute,
            };
            if ( value ) {
              completeSteps( true );
              if ( values.startDate ) newValues.startDate = moment.tz( value );
              if ( values.startTime ) newValues.startTime = moment.tz( value );
            } else {
              completeSteps( false );
            }
            form.initialize( newValues );
          }}
        />
      </Col>
    </Row>
  );
};
